import { BaseUser } from './base-user.model';
import { LocalizationLanguage } from '../enums/localization-language.enum';

export class User extends BaseUser {
    assignedToNewsLetter: boolean;

    avatarExpirationTime?: Date;

    facebookId?: number;

    instagramId?: number;

    isAllTicketsFilterDefault?: boolean;

    isChatSendingByEnter: boolean;

    isCompany: boolean;

    isFeedViewMinimized?: boolean;

    localizationLanguage: LocalizationLanguage;

    showFeedAtLeftSide?: boolean;

    tikTokId: string;

    tikTokUserName: string;

    youtubeId: string;

    youtubeUserName: string;
}
